 
 
import { IPeriodData } from 'views/ProFormaTable/types';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import PeriodCellValue from '../../DevelopmentUsesTable/PeriodCellValue/PeriodCellValue';
import { getUsesPeriodDisplayValue } from '../helpers';

export interface IProjectActualsCashFlowPeriodsProps {
    periods: IPeriodData[];
    showCentsFormat: string;
}

const ProjectActualsCashFlowPeriods = ({ periods, showCentsFormat }: IProjectActualsCashFlowPeriodsProps) => {
    /**
     * Before current period - show funded value
     * In current period - show funded + projected value
     * After current period - show projected value
    */

    let currentPeriodReached = false;

    return (
        <>
            {periods?.map((period, index) => {
                const periodDisplayValue = getUsesPeriodDisplayValue(period, currentPeriodReached);
                currentPeriodReached = periodDisplayValue.currentPeriodReached;

                return (
                    <PeriodCellValue
                        key={`usesPeriod-${period.periodName}`}
                        tooltipId={`usesPeriod-${index}`}
                        period={{ label: period?.periodName, value: period?.periodName }}
                        value={numeralFormatterCurrency(periodDisplayValue.value, showCentsFormat)}
                        cellClassName="NSTable__tbody__tr__td text-dark text-right"
                    />
                );
            })}
        </>
    );
};

export default ProjectActualsCashFlowPeriods;
